<div class="app-loading" *ngIf="loading">
  <div class="logo"></div>
  <svg class="spinner" viewBox="25 25 50 50">
    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
  </svg>
  <p class="app-loading-message">{{loadingMessage}}</p>
</div>

<div class="container-select-ngo">

  <div class="content-left-select-ngo" >

    <ng-container *ngIf="type!='causes'">
      <h4>ESCOLHA A ORGANIZAÇÃO</h4>
      <div class="search-select-ngo-left">
          <label for="search-ngo-by-name">Pesquise o nome da organizaçao</label>
          <input type="text" id="search-ngo-by-name" placeholder="Digite o nome da organização" (keyup)="changeFilterName($event)">
      </div>
    </ng-container>   

    <div class="container-list-ngo" *ngIf="ngosList != null && ngosList.length > 0" >
      <div class="container-ngo" *ngFor="let ngo of ngosList">
        <input type="checkbox" id="{{ngo.ngoId}}" name="{{ngo.ngoName}}" value="{{ngo.ngoId}}" >
        <label for="{{ngo.ngoId}}" (click)="selectNgo(ngo)" [tooltip]="ngo.ngoName" [ngClass]="{'actived': ngo.selected}">
          <img [src]="ngo.ngoLogo" alt="Logo da {{ngo.ngoName}}" >
        </label>
      </div>
    </div>

    <div class="container-list-ngo" *ngIf="causesList != null && causesList.length > 0" >
      <div class="container-ngo" *ngFor="let ngo of causesList">
        <input type="checkbox" id="{{ngo.id}}" name="{{ngo.name}}" value="{{ngo.id}}" >
        <label for="{{ngo.id}}" (click)="selectCause(ngo)" [tooltip]="ngo.name" [ngClass]="{'actived': ngo.selected}">
          <img [src]="ngo.imageLogo" alt="Logo da {{ngo.name}}" >
        </label>
      </div>
    </div>

    <div class="container-list-ngo no-found-ongs" *ngIf="showError">
      <div>
        <img src="../../../assets/img/bee_pensando.png" alt="Abelinha pensando">
      </div>
      <div>
        <h3>
          Infelizmente, ainda não temos uma Organização que corresponde as sua busca.
        </h3>
      </div>
    </div>

    <div class="list-pagination">
      <ng-container *ngFor="let page of totalPages; let i = index">
        <input type="radio" id="{{i}}" name="pages" value="{{i}}">
        <label for="{{i}}" (click)="filteredOngs(i)">{{i+1}}</label>
      </ng-container>
    </div>

  </div>

  <div class="content-right-select-ngo" *ngIf="type != 'causes'">
    <h4>FILTROS</h4>
    <div class="search-select-ngo-right">

      <label for="search-ngo-by-state" style="display: block;">Estados</label>
      <select id="search-ngo-by-state" style="width: 85%;" (change)="changeFilterState($event)">
        <option>Selecione um estado</option>
        <option value="">Todos</option>
        <option value="AC">Acre</option>
        <option value="AL">Alagoas</option>
        <option value="AP">Amapá</option>
        <option value="AM">Amazonas</option>
        <option value="BA">Bahia</option>
        <option value="CE">Ceará</option>
        <option value="DF">Distrito Federal</option>
        <option value="ES">Espírito Santo</option>
        <option value="GO">Goiás</option>
        <option value="MA">Maranhão</option>
        <option value="MT">Mato Grosso</option>
        <option value="MS">Mato Grosso do Sul</option>
        <option value="MG">Minas Gerais</option>
        <option value="PA">Pará</option>
        <option value="PB">Paraíba</option>
        <option value="PR">Paraná</option>
        <option value="PE">Pernambuco</option>
        <option value="PI">Piauí</option>
        <option value="RJ">Rio de Janeiro</option>
        <option value="RN">Rio Grande do Norte</option>
        <option value="RS">Rio Grande do Sul</option>
        <option value="RO">Rondônia</option>
        <option value="RR">Roraima</option>
        <option value="SC">Santa Catarina</option>
        <option value="SP">São Paulo</option>
        <option value="SE">Sergipe</option>
        <option value="TO">Tocantins</option>
      </select>

      <ng-container *ngIf=" type !='causes'">
        <label>Categorias</label>
        <fieldset class="category-container">
          <ul id="listCategory" class="list-group-category d-none">

            <li class="card-filter-cause" *ngIf="category == null">
                <div class="btn-filters" (change)="changeFilterCategory('')">
                  <div class="wrap-category-checkbox">
                    <input type="radio" id="todos" name="category" value="todos">
                      <label for="todos" >
                        <i class="fas fa-check-double"></i>
                        <h6>Todos</h6>
                      </label>
                  </div>
                </div>
            </li>

            <ng-container *ngFor="let causa of filtesCauses">
              <li class="tipo-{{causa.friendlyUrl}} card-filter-cause" [class.some]="category != null && category != causa.friendlyUrl">
                  <div class="btn-filters wrap-category-checkbox" id="{{causa.friendlyUrl}}" (change)="changeFilterCategory(causa.friendlyUrl)" >
                    <!-- <div class="wrap-category-checkbox"> -->
                      <input type="radio" id="{{causa.name}}" name="category" value="{{causa.name}}">
                      <label for="{{causa.name}}" >
                        <img src="{{causa.imageLogo}}" alt="{{causa.name}}">
                        <h6>{{causa.name}}</h6>
                      </label>
                    <!-- </div> -->
                  </div>
              </li>
            </ng-container>
            
          </ul>
        </fieldset>  
      </ng-container>

    </div>
  </div>

</div>
